<template><div><h1 id="projektfinanzierung" tabindex="-1"><a class="header-anchor" href="#projektfinanzierung"><span>Projektfinanzierung</span></a></h1>
<p>Projektfinanzierung — Auswertung von Projekten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung wertet die Projekte aus, die zu den definierten Projektgruppen gehören, eingeschränkt auf den gewählten Zeitraum [Jahr von - Jahr bis]. Das Ergebnis ist eine Datei im Text- oder Tabellenformat (tab-delimited).</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Projektfinanzierung</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Projektgruppen</dt>
<dd>mit Kommas trennen, mit ! ausschliessen, * alle</dd>
<dt>Jahr von</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Jahr bis</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Landscape)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ProjGr.</td>
<td>Projektgruppe</td>
</tr>
<tr>
<td>Projekt</td>
<td>Projektnummer (innerhalb der Projektgruppe)</td>
</tr>
<tr>
<td>Bezeichnung</td>
<td>Kurzbezeichnung des Projekts</td>
</tr>
<tr>
<td>Jahr</td>
<td>Jahr</td>
</tr>
<tr>
<td>Anteil</td>
<td>Wert des Anteils, den Organisation an das Projekt zahlt</td>
</tr>
<tr>
<td>Saldovor</td>
<td>Wert aus dem Vorjahr übernommen für das Projekt</td>
</tr>
<tr>
<td>Eing.Indiv.</td>
<td>Wert aus Eingang aus individuellem Marketing</td>
</tr>
<tr>
<td>Eing.Koll.</td>
<td>Wert aus Eingang aus kollektivem Marketing</td>
</tr>
<tr>
<td>Eing.Weit.</td>
<td>Wert aus Eingang aus weiteren Quellen</td>
</tr>
<tr>
<td>Saldo</td>
<td>Wert Saldo des Projekts</td>
</tr>
<tr>
<td>Betrag erwartet</td>
<td>Wert &quot;zugesagt&quot; aus Projekttabelle minus bereits eingegangenes Geld pro Projekt</td>
</tr>
<tr>
<td>Total</td>
<td>1. Total pro Projekt</td>
</tr>
<tr>
<td>Total</td>
<td>2. Total pro Projektgruppe</td>
</tr>
<tr>
<td>Total</td>
<td>3. Total = Gesamtsumme</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                          19.02.2004 12:11:08 svw  Seite     0</span>
<span class="line"></span>
<span class="line">                             Projektfinanzierung</span>
<span class="line">                Projektgruppen: 200BE</span>
<span class="line">                Jahr von......: 2003  bis: 2003</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">ProjGr.  Projekt Bezeichnung Jahr HV-Antl.       Saldovor Eing.Indiv.  Eing.Koll.  Eing.Weit.       Saldo    Betrag erwartet</span>
<span class="line">-------- ------- ----------- ---- ----------- ----------- ----------- ----------- ----------- ----------- -----------</span>
<span class="line">200BE    822101  BE01        2003    56333.00        0.00        0.00        0.00        0.00    56333.00        0.00</span>
<span class="line">.        822130  BE30        2003   114000.00        0.00    37988.40        0.00        0.00    76011.60        0.00</span>
<span class="line">.        822131  BE31:GEEC   2003    93000.00        0.00     7510.00        0.00        0.00    85490.00        0.00</span>
<span class="line">.        822160  BE60        2003        0.00        0.00        0.00        0.00        0.00        0.00        0.00</span>
<span class="line">.        822161  BE61        2003        0.00        0.00        0.00        0.00        0.00        0.00        0.00</span>
<span class="line">.        822173  BE73        2003        0.00        0.00        0.00        0.00        0.00        0.00        0.00</span>
<span class="line">.        822174  BE74        2003        0.00        0.00        0.00        0.00        0.00        0.00        0.00</span>
<span class="line">.        822190  BE90        2003     3333.00        0.00        0.00        0.00        0.00     3333.00        0.00</span>
<span class="line">                                                          ----------- ----------- -----------             -----------</span>
<span class="line">                                                             45498.40        0.00        0.00                    0.00 TOTAL</span>
<span class="line">                                                          ----------- ----------- -----------             -----------</span>
<span class="line">                                                             45498.40        0.00        0.00                    0.00 TOTAL</span>
<span class="line"></span>
<span class="line">                                                          ----------- ----------- -----------             -----------</span>
<span class="line">                                                             45498.40        0.00        0.00                    0.00 TOTAL</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Das Projekt BE01 weist 2003 einen Saldo von 56'333 aus, wobei 56'333 davon Organisation-Anteil sind.</p>
</div></template>


